<template>
  <div id="consumableList">
    <FilterFrame
      ref="filter"
      :filter-form="recordFilter"
      @search="onSearchValue('search')"
      @clear="clearSearch()"
      @onSearchValue="checkExportRule"
    />
    <div class="title_bar">
      <div class="left" />
      <div class="right">
        <el-button
          icon="icon-plus"
          round
          @click="goEdit('new', null)"
        >
          新增
        </el-button>
        <el-button
          icon="icon-output"
          round
          @click="onSearchValue('export')"
        >
          匯出
        </el-button>
      </div>
    </div>
    <el-table
      class="newslist"
      :data="ListData"
      empty-text="目前無耗材"
    >
      <el-table-column
        prop="ConsumableSn"
        label="耗材代碼"
      />
      <el-table-column
        prop="Name"
        label="耗材名稱"
      />
      <el-table-column
        prop="Quantity"
        label="數量"
      >
        <template slot-scope="scope">
          <span :class="{'unsafe': scope.row.Quantity < scope.row.SafetyStock}">
            {{ scope.row.Quantity }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="SafetyStock"
        label="安全庫存量"
      />
      <el-table-column
        prop="BrandName"
        label="廠牌"
      />
      <el-table-column
        prop="SpecModel"
        label="規格/型號"
      />
      <el-table-column
        prop="Note"
        label="備註"
      />
      <el-table-column
        label="操作"
        fixed="right"
        width="180"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            @click="goEdit('edit', scope.row.ConsumableId)"
          >
            編輯
          </el-button>
          <el-button
            size="mini"
            type="danger"
            plain
            @click="deleteConsumable(scope.row.ConsumableId)"
          >
            刪除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="loading" />
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      :page-size="maxCount"
      :total="listTotalCount"
      @current-change="getList"
    />
    <el-dialog
      id="createSentryDialog"
      :visible.sync="isEditDialogShow"
      :close-on-click-modal="false"
      custom-class="sm-size"
      @closed="handleCloseEditDialog"
    >
      <div slot="title">
        <div class="dialog-title">
          {{ editDialogType }}耗材
        </div>
        <div class="dialog-subTitle">
          可以在此{{ editDialogType }}資料
        </div>
      </div>
      <el-form
        ref="editData"
        class="list"
        :model="editData"
        status-icon
        label-position="left"
        :rules="rule"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="耗材代碼">
              <el-input
                v-model="editData.ConsumableSn"
                placeholder="請輸入耗材代碼"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="耗材名稱"
              prop="Name"
            >
              <el-input
                v-model="editData.Name"
                placeholder="請輸入耗材名稱"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="數量"
              prop="Quantity"
            >
              <el-input
                v-model="editData.Quantity"
                type="number"
                placeholder="請輸入數量"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="安全庫存量"
              prop="SafetyStock"
            >
              <el-input
                v-model="editData.SafetyStock"
                type="number"
                placeholder="請輸入安全庫存量"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="廠牌">
              <el-input
                v-model="editData.BrandName"
                placeholder="請輸入廠牌"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="規格型號">
              <el-input
                v-model="editData.SpecModel"
                placeholder="請輸入規格型號"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="備註">
              <el-input
                v-model="editData.Note"
                type="textarea"
                maxlength="200"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="isEditDialogShow=false"
        >取消</el-button>
        <el-button
          type="primary"
          round
          @click="handleSubmitConsumableData"
        >送出</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'
import FilterFrame from '@/components/FilterFrame'
export default {
  components: {
    FilterFrame,
    TableLoading
  },
  data () {
    return {
      filter: {},
      recordFilter: [
        {
          label: '耗材名稱',
          name: 'name',
          type: 'input',
          value: ''
        },
        {
          label: '耗材代碼',
          name: 'consumableNumber',
          type: 'input',
          value: ''
        }
      ],
      loading: false,
      maxCount: 50,
      ListData: [],
      listTotalCount: 0,
      nowPage: 1,
      canClickButton: true,
      isEditDialogShow: false,
      editDialogType: '',
      editData: {
        ConsumableId: null,
        ConsumableSn: null,
        Name: null,
        Quantity: null,
        SafetyStock: null,
        BrandName: null,
        SpecModel: null,
        Note: null
      },
      rule: {
        Name: [
          { required: true, message: '欄位不可為空', trigger: 'blur' }
        ],
        Quantity: [
          { required: true, message: '欄位不可為空', trigger: 'blur' }
        ],
        SafetyStock: [
          { required: true, message: '欄位不可為空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    if (!JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount && !JSON.parse(localStorage.getItem('loginUserInfo')).IsFromEip) {
      this.$alert('沒有訪問權限', '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        this.$router.back()
      })
      return false
    }
    this.getList()
  },
  methods: {
    // 查詢
    search (such_val) {
      if (this.canClickButton) {
        this.canClickButton = false
        this.ListData = []
        window.scrollTo(0, 0)
        this.getList()
      }
      setTimeout(() => {
        this.canClickButton = true
      }, 1000)
    },
    // 清除搜尋條件
    clearSearch () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.filter = {}
        this.ListData = []
        this.loading = true
        window.scrollTo(0, 0)
        this.getList()
      }
      setTimeout(() => {
        this.canClickButton = true
      }, 1000)
    },
    getList (page = 1) {
      this.loading = true
      this.nowPage = page
      apiAsset.Consumable.GetConsumables({
        Offset: (page - 1) * this.maxCount,
        MaxCount: this.maxCount,
        ...this.filter
      }).then(res => {
        console.log(res)
        this.ListData = res.data.Data
        this.listTotalCount = res.data.Total
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    },
    getConsumableData (ConsumableId) {
      this.loading = true
      const params = {
        ConsumableId
      }
      apiAsset.Consumable.GetConsumable(params).then(res => {
        console.log(res)
        this.editData = {
          ...res.data,
          ConsumableId
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    },
    onSearchValue (type) {
      this.$refs.filter.onSearchValue()
      switch (type) {
        case 'search':
          this.search()
          break
        case 'export':
          this.exportConsumables()
          break
      }
    },
    checkExportRule (such_val) {
      this.filter = {
        'Filter.ConsumableSn': such_val.consumableNumber ? such_val.consumableNumber : undefined,
        'Filter.ConsumableName': such_val.name ? such_val.name : undefined
      }
    },
    exportConsumables () {
      const config = {
        responseType: 'blob',
        params: this.filter
      }
      apiAsset.Consumable.GetExportExcelConsumable(config).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${dayjs().format('YYYYMMDD')}耗材清冊.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }).catch(err => {
        console.log(err)
      })
    },
    goEdit (type, id) {
      if (type === 'new') {
        this.editDialogType = '新增'
        this.isEditDialogShow = true
      } else {
        this.editDialogType = '編輯'
        this.getConsumableData(id)
        this.isEditDialogShow = true
      }
    },
    handleCloseEditDialog () {
      this.editData = {
        ConsumableId: null,
        ConsumableSn: null,
        Name: null,
        Quantity: null,
        SafetyStock: null,
        BrandName: null,
        SpecModel: null,
        Note: null
      }
      this.$refs.editData.resetFields()
    },
    // 送出按鈕
    handleSubmitConsumableData () {
      const vobj = this
      vobj.$refs.editData.validate((valid) => {
        if (valid) {
          if (vobj.editData.Quantity < vobj.editData.SafetyStock) {
            vobj.$confirm('數量低於安全庫存量! 請儘快採購。', '', {
              confirmButtonText: '確定',
              confirmButtonClass: 'el-button--success',
              cancelButtonText: '取消',
              closeOnClickModal: false
            }).then(() => {
              vobj.submitConsumableData()
            }).catch(e => {})
          } else {
            vobj.submitConsumableData()
          }
        }
      })
    },
    submitConsumableData () {
      const vobj = this
      const params = {
        ...vobj.editData
      }
      if (vobj.editData.ConsumableId) {
        apiAsset.Consumable.PutConsumable(params)
          .then(res => {
            console.log(res)
            vobj.$alert('耗材編輯成功。', '', {
              confirmButtonText: '確定',
              callback: () => {
                vobj.getList(vobj.nowPage)
                vobj.isEditDialogShow = false
              }
            })
          })
          .catch(err => {
            console.log('err', err)
            vobj.$alert('耗材編輯失敗', '', {
              confirmButtonText: '確定',
              callback: action => {}
            })
          })
      } else {
        apiAsset.Consumable.PostConsumable(params)
          .then(res => {
            console.log(res)
            vobj.$alert('耗材新增成功。', '', {
              confirmButtonText: '確定',
              callback: () => {
                vobj.getList(this.nowPage)
                vobj.isEditDialogShow = false
              }
            })
          })
          .catch(err => {
            console.log('err', err)
            vobj.$alert('耗材新增失敗', '', {
              confirmButtonText: '確定',
              callback: action => {}
            })
          })
      }
    },
    deleteConsumable (ConsumableId) {
      this.$confirm('耗材刪除後無法復原，確認是否刪除？', '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      })
        .then(() => {
          const params = {
            ConsumableId
          }
          apiAsset.Consumable.DeleteConsumable(params)
            .then(res => {
              console.log(res)
              this.getList(this.nowPage)
            })
            .catch(err => {
              console.log(err)
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="sass" scoped>
#consumableList
  text-align: center
  padding: 20px 0 10px
  height: 100%
  .title_bar
    .right button
      margin-left: 16px
    display: flex
    justify-content: space-between
    align-items: center
    margin: 20px 0
  .title_bar.center
    margin: 20px 0 10px 0
  .newslist
    font-size: 15px
    ::v-deep .el-table
      +basicTable
    .unsafe
      color: $dangerColor

  .el-pagination
    display: flex
    justify-content: flex-start
    margin-top: 28px
  ::v-deep .el-dialog
    +basicDialog
    border-radius: 8px
    .el-dialog__header
      .dialog-title
        font-size: 25px
        font-weight: bold
        margin-bottom: 5px
      .dialog-subTitle
        font-size: 15px
        color: #666666
    .el-dialog__footer
      text-align: center
</style>
